import navLogo from "../assets/nav-logo.png";
import footerLogo from "../assets/footer-logo.png";

const images = {
  navLogo,
  footerLogo,
};

export default images;
